import { FC } from 'react'
import {
  FieldValidationError,
  SwitchLineInput,
  TextInputField,
  Flex
} from '@sequencehq/core-components'
import { CustomerContactFieldsConfig } from './useContactModalForm'
import {
  isPrimaryBillingContact,
  isShippingContact,
  receivesBillingNotifications,
  setBillingNotifications
} from 'CustomerContacts/utils/contactPurposes'

interface Props {
  fieldsConfig: CustomerContactFieldsConfig
  formErrors?: { message: string }[]
  hideLabels?: boolean
}

export const ContactModalForm: FC<Props> = ({
  fieldsConfig,
  formErrors,
  hideLabels = false
}) => {
  const contactRoles = {
    purposes: fieldsConfig.purposes.value,
    notificationSubscriptions: fieldsConfig.notificationSubscriptions.value
  }
  // The primary and shipping contacts always receive notifications, so
  // there's nothing to opt out of.
  const isAlwaysNotified =
    isPrimaryBillingContact(contactRoles) || isShippingContact(contactRoles)

  return (
    <Flex direction="column" gap="16px">
      <TextInputField
        data-testid="contact.name"
        label={!hideLabels ? 'Full name' : undefined}
        value={fieldsConfig.name.value}
        validationErrors={fieldsConfig.name.validationErrors}
        onChange={e => fieldsConfig.name.onChange(e.target.value)}
        placeholder="Full name"
      />
      <TextInputField
        data-testid="contact.email"
        label={!hideLabels ? 'Email' : undefined}
        value={fieldsConfig.email.value}
        onChange={e => fieldsConfig.email.onChange(e.target.value)}
        validationErrors={fieldsConfig.email.validationErrors}
        placeholder="Email"
        data-1p-ignore
        data-lpignore
      />
      {!isAlwaysNotified && (
        <>
          <SwitchLineInput
            data-testid="contact.receivesNotifications"
            value={receivesBillingNotifications(contactRoles)}
            onChange={checked =>
              fieldsConfig.notificationSubscriptions.onChange(
                setBillingNotifications(contactRoles, checked)
                  .notificationSubscriptions
              )
            }
            text="Send invoice notifications and payment reminders to this recipient"
          />
          <FieldValidationError
            validationErrors={
              fieldsConfig.notificationSubscriptions.validationErrors
            }
            data-testid="contact.notificationSubscriptions.validationError"
          />
        </>
      )}
      <FieldValidationError
        validationErrors={formErrors}
        data-testid="contact.formError"
      />
    </Flex>
  )
}
